import vue from 'vue'
import router from '@/router'
import {
  getQrCode,
  loginForm,
  getLoginCode,
  logout,
  logoutAuto,
  checkIdentity,
  reLogin,
  rePwd,
  rePhone,
  getUserInfo,
  editUserInfo,
  getMenuTree,
  getQrStatus, refreshToken
} from "@/services/login";
import {Message, MessageBox} from "element-ui";
import sensors from "sa-sdk-javascript";

const state = {
  loginUser: vue.ls.get('loginUser'),//需要数据共享
  identity: 1,
  loginCode: null,
  userInfo: {},
  changePassword: false,//修改密码
  changePhone: false,//修改手机号
  basicBool: false,
  loginTips: '',
  wx_code: '',//微信登录二维码内容
  checkMenu: vue.ls.get('checkMenu'),
  editableTabs: vue.ls.get('editableTabs'),
  menuTree: vue.ls.get('menuTree'),
  isRelease: vue.ls.get('isRelease'),//是否有发布报价单的权限
  codeState: '',
};

const getters = {
  loginUser: () => state.loginUser ? state.loginUser : vue.ls.get('loginUser'),
  identity: () => state.identity,
  loginCode: () => state.loginCode,
  userInfo: () => state.userInfo,
  basicBool: () => state.basicBool,
  changePassword: () => state.changePassword,
  changePhone: () => state.changePhone,
  loginTips: () => state.loginTips,
  wx_code: () => state.wx_code,
  checkMenu: () => state.checkMenu ? state.checkMenu : vue.ls.get('checkMenu'),
  editableTabs: () => state.editableTabs ? state.editableTabs : vue.ls.get('editableTabs'),
  menuTree: () => state.menuTree ? state.menuTree : vue.ls.get('menuTree'),
  isRelease: () => state.isRelease ? state.isRelease : vue.ls.get('isRelease'),//是否有发布报价单的权限
  codeState: () => state.codeState,
};

const actions = {
  getQrCode({commit, dispatch}, objc) {
    getQrCode().then((res) => {
      commit('updateState', {state: 'wx_code', update: res.data});
      commit('updateState', {state: 'codeState', update: {status: '0'}});
    })
  },
  getQrStatus({commit, dispatch}, objc) {
    getQrStatus(objc.id).then((res) => {
      if (res.code == 0) {
        commit('updateState', {state: 'codeState', update: res.data});
        const {guid, status} = res.data;
        if (status == 0) {
          //todo 二维码正常可以扫
        }
        if (status && status != 0) {
          // 第一个是accessToken   第二个是refreshToken
          let arr = status.split(',');
          let params = {
            access_token: arr[0],
            refresh_token: arr[1],
            grant_type: 'refresh_token'
          };
          dispatch('refreshToken', {params, type: objc.type});
        }
      } else {
        //二维码失效
        commit('updateState', {state: 'codeState', update: {status: '1'}});
      }
    })
  },
  //刷新token
  refreshToken({commit, dispatch}, objc) {
    refreshToken(objc.params).then((res) => {
      let {code, msg, data} = res;
      if (code == 1) {
        Message.warning(msg);
      }
      if (code == 0) {
        //1、存储token(cookie) 2、跳转页面 3、提示登陆成功4、设置选中菜单
        //设置cookie 30分钟失效
        let time = +new Date() + data.expires_in * 1000;//半个小时后的时间戳
        vue.$cookies.set('tokenTime', time);
        vue.$cookies.set('token', 'Bearer' + ' ' + data.access_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('re_token', data.refresh_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('access_token', data.access_token, `${data.expires_in / 60}min`);

        const {identity, userTypr} = data.user_info;
        //todo 根据 身份：identity 状态：userTypr 来判断是否有权限
        // 若身份=0状态=null,创建用户用户身份=0状态=5 小程序进入平台 无发布权限； pc端走注册流程
        // 若身份=0 状态=4  进入平台，没有发布权限
        // 若身份=1，2，3状态=0 进入平台，有发布权限
        // 若身份=1，2，3状态=1 进入平台，没有发布权限
        // 若身份=1，2，3状态=2 进入平台，有发布权限
        // 若身份=1，2，3状态=3 进入平台，没有发布权限

        //todo 登录后判断用户是否已经进行身份确认，没有确认跳转至身份确认
        if (identity == 0) {
          if (userTypr === "4") {
            //日志采集上报登录用户ID
            commit('updateState', {state: 'isRelease', update: false});
            sensors.loginWithKey('$identity_login_id', data.user_info.id);
            router.push({path: '/dynamic_recommend'});
            commit('updateState', {state: 'loginUser', update: data.user_info});
          }

          if (userTypr == 5 || userTypr == null) {
            //需要去注册
            MessageBox.confirm('登录财粮说需要先注册，是否现在注册？', '温馨提示', {type: 'warning'}).then(() => {
              objc.route.push('/register');
              dispatch('logoutAuto', {type: 'register'});
            }).catch(() => {
              //todo nothing
            })
          }
        } else {
          //todo 身份已经确认的，要判断有没有设置密码，没有就到注册页面
          if (userTypr == 0) {
            commit('updateState', {state: 'isRelease', update: true})
          }
          if (userTypr === "1" || userTypr === "2" || userTypr === '3') {
            commit('updateState', {state: 'isRelease', update: false})
          }
          sensors.loginWithKey('$identity_login_id', data.user_info.id);
          router.push({path: '/dynamic_recommend'});
          commit('updateState', {state: 'loginUser', update: data.user_info});
        }
      }
    })
  },
  //登录
  loginForm({commit, dispatch}, objc) {
    loginForm(objc.params).then((res) => {
      let {code, msg, data} = res;
      if (code == 1) {
        Message.warning(msg);
      }
      if (code == 0) {
        commit('updateState', {state: 'loginTips', update: ''});
        //1、存储token(cookie) 2、跳转页面 3、提示登陆成功4、设置选中菜单
        //设置cookie 30分钟失效
        let time = +new Date() + data.expires_in * 1000;//半个小时后的时间戳
        vue.$cookies.set('tokenTime', time);
        vue.$cookies.set('token', 'Bearer' + ' ' + data.access_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('re_token', data.refresh_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('access_token', data.access_token, `${data.expires_in / 60}min`);

        if (objc.checked) {
          vue.$cookies.set('check', objc.checked);
          //todo 记住账号
          if (objc.params.grant_type == 'app') {
            //记住手机
            vue.$cookies.set('mobile', objc.params.mobile);
          }
          if (objc.params.grant_type == 'password') {
            //记住账号密码
            vue.$cookies.set('mobile', objc.params.username);
            vue.$cookies.set('userInfo', {username: objc.params.username, password: objc.initPwd,});
          }
        } else {
          vue.$cookies.remove('userInfo');
          vue.$cookies.remove('mobile');
        }
        const {identity, userTypr} = data.user_info;
        //todo 根据 身份：identity 状态：userTypr 来判断是否有权限
        // 若身份=0状态=null,创建用户用户身份=0状态=5 小程序进入平台 无发布权限； pc端走注册流程
        // 若身份=0 状态=4  进入平台，没有发布权限
        // 若身份=1，2，3状态=0 进入平台，有发布权限
        // 若身份=1，2，3状态=1 进入平台，没有发布权限
        // 若身份=1，2，3状态=2 进入平台，有发布权限
        // 若身份=1，2，3状态=3 进入平台，没有发布权限

        //todo 登录后判断用户是否已经进行身份确认，没有确认跳转至身份确认
        if (identity == 0) {
          if (userTypr === "4") {
            //日志采集上报登录用户ID
            commit('updateState', {state: 'isRelease', update: false});
            sensors.loginWithKey('$identity_login_id', data.user_info.id);
            router.push({path: '/dynamic_recommend'});
            commit('updateState', {state: 'loginUser', update: data.user_info});
          }

          if (userTypr == 5 || userTypr == null) {
            //需要去注册
            MessageBox.confirm('登录财粮说需要先注册，是否现在注册？', '温馨提示', {type: 'warning'}).then(() => {
              objc.route.push('/register');
              dispatch('logoutAuto', {type: 'register'});
            }).catch(() => {
              //todo nothing
            })
          }
        } else {
          //todo 身份已经确认的，要判断有没有设置密码，没有就到注册页面
          if (userTypr == 0) {
            commit('updateState', {state: 'isRelease', update: true})
          }
          if (userTypr === "1" || userTypr === "2" || userTypr === '3') {
            commit('updateState', {state: 'isRelease', update: false})
          }
          sensors.loginWithKey('$identity_login_id', data.user_info.id);
          router.push({path: '/dynamic_recommend'});
          commit('updateState', {state: 'loginUser', update: data.user_info});
        }

      }
    })
  },
  //获取验证码
  getLoginCode({commit, dispatch}, objc) {
    getLoginCode(objc).then((res) => {
      if (res.code === 0) {
        if (res.data) {
          commit('updateState', {state: 'loginCode', update: res.data});
        } else {
          Message.warning(res.msg);
        }
      }
    })
  },
  //退出登录
  exitLogin({commit}, objc) {
    logout().then((res) => {
      if (res.code == 0) {
        //1 、退出登陆跳转至登陆页面2、清空本地存储
        if (objc.route) {
          objc.route.push('/');
        }
        if (objc.cookie) {
          //删除cookie，有过期时间没有删除掉
          objc.cookie.remove('token');
        }
        vue.ls.clear();
      }
    })
  },
  logoutAuto({commit}, objc) {
    logoutAuto().then((res) => {
      if (res.code == 0) {
        //1 、退出登陆跳转至登陆页面2、清空本地存储
        if (objc.type == 'login') {
          router.push('/');
        }
        vue.$cookies.remove('token');
        vue.ls.clear();
      }
    })
  },
  reLogin({commit, dispatch}, objc) {
    reLogin(objc.params).then((res) => {
      let {code, msg, data} = res;
      if (res.code == 1) {
        Message.warning(msg);
      }
      if (code == 0) {
        //1、存储token(cookie) 2、跳转页面 3、提示登陆成功4、设置选中菜单
        //设置cookie 30分钟失效
        let time = +new Date() + data.expires_in * 1000;//半个小时后的时间戳
        vue.$cookies.set('tokenTime', time);
        vue.$cookies.set('token', 'Bearer' + ' ' + data.access_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('re_token', data.refresh_token, `${data.expires_in / 60}min`);
        vue.$cookies.set('access_token', data.access_token, `${data.expires_in / 60}min`);

        const {identity, userTypr} = data.user_info;
        //todo 根据 身份：identity 状态：userTypr 来判断是否有权限
        // 若身份=0状态=null,创建用户用户身份=0状态=5 小程序进入平台 无发布权限； pc端走注册流程
        // 若身份=0 状态=4  进入平台，没有发布权限
        // 若身份=1，2，3状态=0 进入平台，有发布权限
        // 若身份=1，2，3状态=1 进入平台，没有发布权限
        // 若身份=1，2，3状态=2 进入平台，有发布权限
        // 若身份=1，2，3状态=3 进入平台，没有发布权限

        //todo 登录后判断用户是否已经进行身份确认，没有确认跳转至身份确认
        if (identity == 0) {
          if (userTypr === "4") {
            //日志采集上报登录用户ID
            commit('updateState', {state: 'isRelease', update: false});
            sensors.loginWithKey('$identity_login_id', data.user_info.id);
            router.push({path: '/dynamic_recommend'});
            commit('updateState', {state: 'loginUser', update: data.user_info});
            vue.$cookies.set('loginUser', data.user_info)
          }
          if (userTypr == 5 || userTypr == null) {
            //需要去注册
            MessageBox.confirm('登录财粮说需要先注册，是否现在注册？', '温馨提示', {type: 'warning'}).then(() => {
              objc.route.push('/register');
              dispatch('logoutAuto', {type: 'register'});
            }).catch(() => {
              //todo nothing
            })
          }
        } else {
          //todo 身份已经确认的，要判断有没有设置密码，没有就到注册页面
          if (userTypr == 0) {
            commit('updateState', {state: 'isRelease', update: true})
          }
          if (userTypr === "1" || userTypr === "2" || userTypr === '3') {
            commit('updateState', {state: 'isRelease', update: false})
          }
          sensors.loginWithKey('$identity_login_id', data.user_info.id);
          router.push({path: '/dynamic_recommend'});
          commit('updateState', {state: 'loginUser', update: data.user_info});
        }

      }
    })
  },
  //选择身份进入
  checkIdentity({commit, dispatch}, objc) {
    checkIdentity(objc.params).then((res) => {
      if (res.code === 0) {
        if (objc.route) {
          if (objc.params.identity == 3) {
            objc.route.push({path: '/approving'});
          }
          if (objc.params.identity != 3) {
            //todo 自动登录获取信息(等后端发布)
            dispatch('reLogin', {
              params: {
                grant_type: 'password',
                phong: objc.loginInfo.username,
                password: objc.loginInfo.pwd,
              },
              route: objc.route,
              cookie: objc.cookie
            });

          }
        }
      }
    })
  },
  //修改手机号
  rePhone({commit, dispatch}, objc) {
    rePhone(objc.params).then((res) => {
      if (res.code === 0) {
        Message.success('手机号修改成功！请重新登录');
        dispatch('logoutAuto', {type: 'login'});
        commit('dynamicMy/updateState', {state: 'editVisible', update: false}, {root: true});
      } else {
        Message.warning(res.msg)
      }
    })
  },
  //修改密码
  rePwd({commit, dispatch}, objc) {
    rePwd(objc.params).then((res) => {
      if (res.code === 0) {
        Message.success('密码修改成功！请重新登录');
        dispatch('logoutAuto', {type: 'login'});

      } else {
        Message.warning(res.msg)
      }
    })
  },
  getUserInfo({commit, dispatch}, objc) {
    getUserInfo().then((res) => {
      if (res.code === 0 && res.data) {
        let authorities = [];
        if (res.data && res.data.permissions && res.data.permissions.length > 0) {
          res.data.permissions.map((i) => {
            authorities.push({authority: i});
          })
        }
        //todo 处理权限
        const {identity, userTypr} = res.data.sysUser;
        if (identity == 0) {
          if (userTypr == "4") {
            //日志采集上报登录用户ID
            commit('updateState', {state: 'isRelease', update: false});
          }
        } else {
          //todo 身份已经确认的，要判断有没有设置密码，没有就到注册页面
          if (userTypr == 0) {
            commit('updateState', {state: 'isRelease', update: true})
          }
          if (userTypr == "1" || userTypr == "2" || userTypr == '3') {
            commit('updateState', {state: 'isRelease', update: false})
          }
        }
        commit('updateState', {state: 'loginUser', update: {...res.data.sysUser, authorities}});
        commit('updateState', {state: 'userInfo', update: res.data})
      }
    })
  },
  //编辑用户信息
  editUserInfo({commit, dispatch}, objc) {
    editUserInfo(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'basicBool', update: false})
        Message.success('基本信息修改成功！')
        dispatch('getUserInfo')
      } else {
        Message.warning(res.msg)
      }
    })
  },
  getMenuTree({commit, dispatch}, objc) {
    getMenuTree(objc).then((res) => {
      if (res.code === 0) {
        if (res.data && res.data.length > 0) {
          commit('updateState', {state: 'menuTree', update: res.data});
          //todo 默认选中
          commit('updateState', {state: 'checkMenu', update: res.data[0].path});
          //todo 跳转至财粮通
          // window.open(‘url?id=’+id+‘&name=’+name);
          // window.open(`http://localhost:8080${res.data[0].path}?token=${vue.$cookies.get('token')}&re_token=${vue.$cookies.get('re_token')}`);
          // window.open(`http://dev.cailiangyun.com${res.data[0].path}?token=${vue.$cookies.get('token')}&re_token=${vue.$cookies.get('re_token')}`);
          window.open(`https://www.cailiangyun.com${res.data[0].path}?token=${vue.$cookies.get('token')}&re_token=${vue.$cookies.get('re_token')}`);
          commit('updateState', {
            state: 'editableTabs',
            update: [{name: res.data[0].path, title: res.data[0].name}]
          });
        } else {
          Message.warning('无权限访问，请联系管理员！')
        }
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'loginUser' || payload.state === 'checkMenu'
      || payload.state === 'editableTabs' || payload.state === 'menuTree' || payload.state === 'isRelease') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/login/modules/login.js